import React from 'react';

/**
 * QuickActions - Quick action buttons for common client tasks
 */
const QuickActions = ({ actions, onAction }) => {
    const defaultActions = [
        {
            id: 'upload',
            label: 'Upload Document',
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                </svg>
            ),
            color: 'indigo',
            path: '/portal/documents'
        },
        {
            id: 'applications',
            label: 'View Applications',
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
            ),
            color: 'emerald',
            path: '/portal/applications'
        },
        {
            id: 'message',
            label: 'Contact Consultant',
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
            ),
            color: 'purple',
            path: '/portal/messages'
        },
        {
            id: 'payments',
            label: 'View Payments',
            icon: (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
            ),
            color: 'amber',
            path: '/portal/payments'
        }
    ];

    const actionList = actions || defaultActions;

    const colorMap = {
        indigo: 'bg-indigo-50 hover:bg-indigo-100 text-indigo-600 border-indigo-100',
        emerald: 'bg-emerald-50 hover:bg-emerald-100 text-emerald-600 border-emerald-100',
        purple: 'bg-purple-50 hover:bg-purple-100 text-purple-600 border-purple-100',
        amber: 'bg-amber-50 hover:bg-amber-100 text-amber-600 border-amber-100',
        rose: 'bg-rose-50 hover:bg-rose-100 text-rose-600 border-rose-100',
        blue: 'bg-blue-50 hover:bg-blue-100 text-blue-600 border-blue-100'
    };

    return (
        <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
            <h3 className="text-base font-semibold text-slate-900 mb-4">Quick Actions</h3>
            <div className="grid grid-cols-2 gap-3">
                {actionList.map(action => (
                    <button
                        key={action.id}
                        onClick={() => onAction?.(action)}
                        className={`
                            flex items-center gap-3 p-3 rounded-xl border transition-all duration-200
                            hover:shadow-md hover:-translate-y-0.5
                            ${colorMap[action.color] || colorMap.indigo}
                        `}
                    >
                        {action.icon}
                        <span className="text-sm font-medium truncate">{action.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default QuickActions;
